<template>
    <div class="adminssion-info">
        <div class="info-cantainer">
            <div class="patient-info">
                <p class="txt">{{$t("subscribe.patient")}}：{{subscribehosptailInfo.patientName||'--'}}</p>
                <p class="txt">{{$t("subscribe.submitTime")}}：{{getLocalMinutesTime(subscribehosptailInfo.yuyueZhuyuanCdt)}}</p>
                <p class="txt">{{$t("subscribe.subscribeTime")}}：{{getLocalDateTime(subscribehosptailInfo.planInHospDt)}}</p>
            </div>
            <div class="adminssion-status">
                <p class="status-item">
                    <span class="label">
                        {{$t("subscribe.statusLabel")}}：
                    </span>
                    <span class="value" :class="'val'+subscribehosptailInfo.yuyueZhuyuanStatus">
                        {{statusObj[subscribehosptailInfo.yuyueZhuyuanStatus]}}
                    </span>
                </p>
                <p class="status-item" v-if="subscribehosptailInfo.yuyueZhuyuanStatus == 143004">
                    <span class="label">
                        {{$t("subscribe.cause")}}：
                    </span>
                    <span class="value">
                        {{subscribehosptailInfo.rejectReason}}
                    </span>
                </p>
                <p class="status-item" v-if="subscribehosptailInfo.yuyueZhuyuanStatus == 143002">
                    <span class="label">
                        {{$t("subscribe.hosptailTime")}}：
                    </span>
                    <span class="value">
                        {{getLocalDateTime(subscribehosptailInfo.inHospDt)}}
                    </span>
                </p>
                <p class="flex warningTxt">
                    <van-icon name="warning-o"  />
                    <span>{{$t("subscribe.warningtips")}}</span>
                </p>
            </div>
            <div v-if="subscribehosptailInfo.tenantName && subscribehosptailInfo.tenantName.length > 0" class="tenant-info">
              <img class="image" src="@/assets/img/tennat_info_img.png" alt="">
              <div style="height: 28px"></div>
              <div class="tenant">
                <div class="info-con">
                  <div>
                    <img src="@/assets/img/tennat_info_tel.png" alt="">
                  </div>
                  <span v-if="subscribehosptailInfo.tenantTel.length > 0" class="info-label"><a :href="'tel:' + subscribehosptailInfo.tenantTel" style="color: #606266;">病房电话：{{subscribehosptailInfo.tenantTel}}</a></span>
                  <span v-else class="label">病房电话：---</span>
                </div>
                <div class="info-con" style="margin-top: 8px">
                  <div>
                    <img src="@/assets/img/tennat_info_addr.png" alt="">
                  </div>
                  <span class="info-label">{{subscribehosptailInfo.tenantName}}地址：{{subscribehosptailInfo.tenantAddr.length > 0 ? subscribehosptailInfo.tenantAddr : '---'}}</span>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import {  InhospitalGet } from "@/api/index";
import { getLocalMinutesTime, getLocalDateTime } from "@/utils/date"
export default {
    data () {
        return {
            subscribehosptailInfo:{},
            getLocalMinutesTime,
            getLocalDateTime,
            statusObj:{
                "143001":this.$t("subscribe.statusTxt1"),
                "143002":this.$t("subscribe.statusTxt5"),
                "143003":this.$t("subscribe.statusTxt3"),
                "143004":this.$t("subscribe.statusTxt4")
            }
        }
    },
    created () {
        this.getInfoData()
        document.title = this.$t("appointment.myAppointment")
    },
    methods:{
        getInfoData(){
            const toast = this.$Toast.loading({
                message: this.$t("message.loadingTxt"),
                forbidClick: true,
            });
            InhospitalGet({
                yuyueZhuyuanId:this.$route.query.yuyueZhuyuanId
            }).then(res =>{
                toast.clear();
                if(res.data.errorCode == 0){
                    this.subscribehosptailInfo = res.data.data
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.adminssion-info{
    min-height: 100%;
    background-color: #5CD2FF;
    background-image: url("~@/assets/img/hosp-subscribe-banner.png");
    background-repeat: no-repeat;
    background-size:15rem 7.8rem;
    background-position: top;
    padding: 6.8rem 0.2rem 0.6rem 0.2rem;
    box-sizing: border-box;
    .info-cantainer{
        padding: 0.4rem;
        position: relative;
        &::after{
            position: absolute;
            content: ' ';
            top: 0;
            left: 0;
            width: 100%;
            height: 0.8rem;
            background: linear-gradient(0deg, #0B96F7 0%, #90F1FF 100%);
            border-radius: 0.4rem;
            z-index: 0;
        }
        .patient-info{
            position: relative;
            z-index: 1;
            width: 100%;
            box-sizing: border-box;
            // height: 4.6rem;
            padding: 1.2rem;
            background: #E0F6FF;
            .txt{
                font-size: 0.64rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #606266;
                margin-bottom: 0.4rem;
                &:nth-last-child(1){
                    margin: 0;
                }
            }
            &::after,&::before{
                content: ' ';
                width: 0.8rem;
                height: 0.8rem;
                border-radius: 50%;
                position: absolute;
                bottom: -0.4rem;
                left: -0.4rem;
                background: #5CD2FF;
            }
            &::before{
                left: auto;
                right: -0.4rem;
            }
        }

    }
    .adminssion-status{
        background: #FFFFFF;
        border-radius: 0px 0px 0.52rem 0.52rem;
        box-sizing: border-box;
        padding: 1.6rem 1.2rem 1.3rem 1.2rem;
        .status-item{
            display: flex;
            font-family: PingFang SC;
            margin-bottom: 0.3rem;
            font-weight: 400;
            align-items: center;
            color: #606266;
            .label{
                flex: 0 0 auto;
                font-size: 0.64rem;
            }
            .value{
                font-size: 0.64rem;
                flex: 1;
            }
            .val143001{
                font-size: 0.96rem;
                color: #FFC00F;
            }
            .val143002{
                font-size: 0.96rem;
                color: #49A7FF;
            }
            .val143003{
                font-size: 0.96rem;
                color: #909399;
            }
            .val143004{
                font-size: 0.96rem;
                color: #FF3535;
            }
        }
        .warningTxt{
            align-items: flex-start;
            margin-top: 0.3rem;
            font-size: 0.56rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FF671C;
            // line-height:0.6em;
            .van-icon {
                padding-top: 0.1rem;
                margin-right: 0.2rem;
            }
        }
    }
  .tenant-info {
    color: #606266;
    margin-top: 12px;
    .tenant {
      background: #FFFFFF;
      border-radius: 0.52rem;
      padding: 1.2rem 1.2rem 1.0rem 1.2rem;
      .info-con {
        display: flex;
        .info-label {
          font-size: 0.64rem;
          line-height: 1.8em;
        }
        img {
          font-size: 0.5rem;
          width: 1.2em;
          margin-right: 10px;
          margin-top: 0.5em;
        }
      }
    }
    .image {
      font-size: 0.64rem;
      float: right;
      margin-right: 1.2em;
      width: 5.0em;
    }
  }
}
</style>
